import { Component, Input } from '@angular/core';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { LeaderboardResultType } from '../../shared/types/leaderboard-result-type';
import { OeAppService } from '../../shared/oe-app.service';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';

@Component({
  selector: 'lp2-leaderboard-inactive',
  templateUrl: './leaderboard-inactive.component.html',
  styleUrls: ['./leaderboard-inactive.component.scss'],
})
export class LeaderboardInactiveComponent {
  @Input()
  set leaguesData(data: GamificationLeagueDto[]) {
    this.leagues = data;
    this.initLeagueData();
  }

  @Input()
  set gamificationProfileData(data: GamificationProfileDto) {
    this.gamificationProfile = data;
    this.initLeagueData();
  }

  @Input()
  set gamificationSettings(data: GamificationSettingsDto) {
    if (data) {
      this.topQualify = data.promotionZoneIndex;
    }
  }

  topQualify = 10;

  gamificationProfile: GamificationProfileDto;

  currentLeagueIndex: number;

  leagues: GamificationLeagueDto[];

  leaderboardResultType = LeaderboardResultType;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  constructor(private oeApp: OeAppService) {}

  initLeagueData() {
    if (this.gamificationProfile && this.leagues) {
      this.currentLeagueIndex = this.leagues.findIndex(
        (e: GamificationLeagueDto) => e.id === this.gamificationProfile.leagueId
      );
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/leaderboard-inactive/leaderboard-inactive.component.ts